var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"badge","type":"animation"},on:{"after-enter":_vm.completeEntrance}},[_c('Badge',{staticClass:"kitty-karma",attrs:{"img":_vm.$store.state.config.general.kitty_karma.icon.sizes.large}},[_vm._v("\n\t\t-"),_c('AnimatedNumber',{staticClass:"count",attrs:{"number":_vm.lostPoints}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Points")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2898cb6e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/KittyKarma.vue
// module id = null
// module chunks = 